<!--
Author: TangChen
Date: 2018-11-19
Desc: 检查账户信息，由index.js 配置引入
 -->
<template>
    <div :class="'bizcomp-check-acct bizcomp ' + className">
        <comp-title :title="title" />
        <nav-bar v-if="navs.length>1" :navs="navs" />
        <!-- <user-info v-if="activeId==='0102'" :fn="true" v-on:fn-back="updateIndex" /> -->
        <el-row v-if="activeId==='0105'" class="inv-identification">
            <div class="investor-tips">
                <div class="tit-warn">
                    <i class="el-alert__icon el-icon-warning is-big" />
                    <span class="tit-warn-text">
                        根据
                        <span>《证券期货投资者适当性管理办法》</span>
                        等相关规定，经营机构向普通投资者销售产品或提供服务前，需投资者提供如下承诺：
                    </span>
                </div>
                <div class="investor-info" v-html="agrCon.content" />
                <el-form
                    ref="ruleForm"
                    class="two-cols-form"
                    :model="ruleForm"
                    :rules="rules"
                    label-width="100px"
                    size="small"
                >
                    <el-row>
                        <el-col :span="14">
                            <el-form-item v-if="isPwdCheck" label="交易密码：" prop="pwd">
                                <el-input v-model="ruleForm.pwd" type="password" :maxlength="20" />
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <div class="dialog-footer">
                <el-button v-on:click.once="$router.back()">
                    取消
                </el-button>
                <el-button type="primary" v-on:click="submitForm">
                    我已阅知风险，并同意准入
                </el-button>
            </div>
        </el-row>
        <change-pwd v-if="activeId==='0101'" way="trade" :fn="true" v-on:fn-back="updateIndex" />
        <change-pwd v-if="activeId==='0111'" way="login" :fn="true" v-on:fn-back="updateIndex" />
        <risk-ques v-if="activeId==='0201' && riskQuesShow" :fn="true" v-on:fn-back="updateIndex" />
        <risk v-if="riskResultShow && !riskQuesShow" :fn="true" v-on:fn-back="updateIndex" v-on:risk-test-continue="continueTest" />
        <user-info v-if="activeId==='0102'" :fn="true" v-on:fn-back="updateIndex" />
        <inv-info v-if="activeId==='0103'" :fn="true" v-on:fn-back="updateIndex" />
        <crs-info v-if="activeId==='0104'" :fn="true" v-on:fn-back="updateIndex" />
        <bank-operation v-if="activeId==='0202'" :fn="true" v-on:fn-back="updateIndex" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import navBar from "@/components/layout/navBar.vue";
import riskQues from "@/components/acctInfo/riskQues.vue";
import risk from "@/bizcomponents/acctManager/risk.vue";
import invInfo from "@/components/acctInfo/invInfo.vue";
import changePwd from "@/components/acctInfo/changePwd.vue";
import crsInfo from "@/components/acctInfo/crsInfo.vue";
import userInfo from "@/components/acctInfo/userInfo";
import bankOperation from "@/components/form/bankOperation";
export default {
    name: "CheckAcct",
    components: {
        navBar,
        riskQues,
        risk,
        invInfo,
        changePwd,
        crsInfo,
        userInfo,
        bankOperation
    },
    mixins: [mixin],
    data() {
        return {
            check: [],
            navs: [],
            activeId: "",
            indexNum: -1,
            isPwdCheck: false,
            agrCon: {},
            ruleForm: {
                pwd: ""
            },
            rules: {
                pwd: [
                    {
                        required: true,
                        message: "请输入交易密码",
                        trigger: "blur"
                    }
                ]
            },
            identiFlag: "1",
            riskResultShow: false,
            riskQuesShow: true
        };
    },
    watch: {
        indexNum(val) {
            this.$set(this.navs, val, {
                val: this.navs[val].val,
                id: this.navs[val].id,
                active: true
            });
            this.activeId = this.navs[val].id;
            if (this.activeId === "0105") {
                this.getProtocol();
            }
        }
    },
    created() {
        this.isPwdCheck = this.$cache.getPwdCheck("P3");
        this.acctInfo = this.$cache.getUser();
        this.check = this.$util.acctStatus(
            this.acctInfo,
            this.$route.query.cate
        );
        this.check.forEach(item => {
            this.navs.push({ val: item.tit, id: item.id });
        });
        this.indexNum++;
        if (this.navs.length > 1) {
            this.navs[this.navs.length - 1].icon = "fa fa-check";
        }
    },
    methods: {
        submitForm() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    this.identification();
                } else {
                    return false;
                }
            });
        },
        // 准入
        identification() {
            const _this = this;
            if( _this.identiFlag === "0" ) {
                return false;
            }
            _this.identiFlag = "0";
            this.$req({
                method: "POST",
                url: "acct/sdx/sign",
                timeout: 20000,
                data: { tradepwd: this.$util.enc(this.ruleForm.pwd) }
            }).then(res => {
                if (res.code === "0000000") {
                    const info = _this.$cache.getUser();
                    info.isneedidentify = "0";
                    _this.$store.dispatch("setInfo", info).then(() => {
                        _this.$message({
                            type: "success",
                            message: "准入协议签订成功！",
                            onClose: function() {
                                _this.updateIndex();
                            }
                        });
                    });
                } else {
                    this.$message.error(res.msg);
                    _this.identiFlag = "1";
                }
            }).catch(() => {
                _this.identiFlag = "1";
            });
        },
        continueTest(){
            this.indexNum--;
            this.riskQuesShow = true;
            this.updateIndex(true);
        },
        updateIndex(flag) {
            if(this.activeId === "0201" && !flag){//riskQues.vue触发的事件flag为false,显示风测结果
                this.riskResultShow = true;//显示风险测评结果
                this.riskQuesShow = false;
                return;
            }
            const _this = this;
            if (this.navs[this.indexNum + 1]) {
                this.riskResultShow = false;
                this.indexNum++;
            } else {
                this.$message({
                    type: "success",
                    message: "用户信息已完善，3秒后返回首页",
                    onClose: function() {
                        _this.$router.push({ name: "home" });
                    }
                });
            }
        },
        getProtocol() {
            let _this = this;
            this.$util.getProtocol("allow").then(res => {
                if (res && res.length === 0) {
                    _this.$alert("基金公司未添加准入协议，请联系公司客服添加", "准入协议", {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: "关闭",
                        customClass: "info-check"
                    }).then(() => {
                        _this.$router.push("/home");
                        return false;
                    }).catch(() => {
                        return false;
                    });
                    return false;
                }
                _this.$util
                    .request("common/protocol/content", res[0])
                    .then(res => {
                        if (res.data) {
                            const con = res.data[0];
                            if (con) {
                                _this.agrCon = con;
                            }
                        }
                    });
            });
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-check-acct {
    padding-bottom: 40px;
    .comp-nav-bar {
        margin: 10px;
    }
    .comp-date-picker {
        width: auto;
    }
    .certexpdate-box {
        padding: 20px 0;
        .el-col {
            .form-text {
                margin-bottom: 10px;
            }
        }
    }
    .inv-identification {
        padding: 10px 40px 10px;
        .tit-warn {
            color: $color-a;
            line-height: 40px;
            i {
                margin-right: 8px;
                vertical-align: middle;
            }
            .tit-warn-text {
                vertical-align: middle;
                color: $text-color2;
                span {
                    font-size: $f20;
                    margin-left: 5px;
                    color: $color-a;
                }
            }
        }
        .dialog-footer {
            text-align: center;
        }
        .investor-info {
            margin: 5px 0 20px;
            border-radius: 4px;
            background: $bg5;
            padding: 10px 17px;
            border: 1px solid $border-color8;
            .tit {
                color: $color-a;
                font-size: $f16;
                line-height: 36px;
            }
            .list {
                color: $text-color1;
                line-height: 24px;
                span {
                    color: $color-c;
                }
            }
        }
    }
    .el-button + .el-button {
        margin-left: 30px;
    }
}
</style>
